import { RefObject, useCallback, useRef } from 'react'

type ReturnType<T> = [RefObject<T>, (options?: ScrollIntoViewOptions) => void]

const useScrollIntoView = <T extends HTMLElement = HTMLDivElement>(): ReturnType<T> => {
  const elementRef = useRef<T>(null)

  const scrollIntoView = useCallback((options?: ScrollIntoViewOptions) => {
    elementRef.current?.scrollIntoView(options)
  }, [])

  return [elementRef, scrollIntoView]
}

export { useScrollIntoView }
